import type { WorkspaceKey } from '@festina-life/api'
import { Checkbox } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'
import { useState } from 'react'

import { useFetchWorkspaceBaseBranchChangesets } from '../../../../uiModels/api/changesets/useFetchWorkspaceBaseBranchChangesets'
import { OperationsLoadedButton } from '../../../operationsButton/OperationsLoadedButton'
import { useDownloadWorkspacePackage } from './useDownloadWorkspacePackage'

export const DownloadWorkspacePanel = ({
  workspaceKey,
}: {
  workspaceKey: WorkspaceKey
}) => {
  const translate = useTranslate()
  const [shouldIncludeBaseBranch, setShouldIncludeBaseBranch] = useState(true)
  const { data: baseBranchChangesets } =
    useFetchWorkspaceBaseBranchChangesets(workspaceKey)
  const { download } = useDownloadWorkspacePackage(workspaceKey)

  return (
    <div className="flex flex-col gap-y-2">
      <Checkbox
        wrapperProps={{
          label: translate('branchesTree.export.includeBaseBranch.label'),
        }}
        checked={shouldIncludeBaseBranch}
        onChange={setShouldIncludeBaseBranch}
      />
      <div className="flex justify-end">
        <OperationsLoadedButton
          variant="primary"
          onClick={() =>
            download(shouldIncludeBaseBranch ? baseBranchChangesets : undefined)
          }
        >
          {translate('workspaceDetailsPanel.tabs.manage.downloadPackage')}
        </OperationsLoadedButton>
      </div>
    </div>
  )
}
